"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TicketsApi =
/*#__PURE__*/
function (_BasicDataHubApi) {
  (0, _inherits2.default)(TicketsApi, _BasicDataHubApi);

  function TicketsApi() {
    (0, _classCallCheck2.default)(this, TicketsApi);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TicketsApi).apply(this, arguments));
  }

  (0, _createClass2.default)(TicketsApi, [{
    key: "getTicketsList",
    value: function () {
      var _getTicketsList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var query,
            _args = arguments;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                return _context.abrupt("return", this._callApi({
                  path: '/v2/tickets',
                  queryParams: _objectSpread({}, query)
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTicketsList() {
        return _getTicketsList.apply(this, arguments);
      }

      return getTicketsList;
    }()
  }, {
    key: "getTicketById",
    value: function () {
      var _getTicketById = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(id) {
        var query,
            _args2 = arguments;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                query = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                return _context2.abrupt("return", this._callApi({
                  path: "/v2/ticket/".concat(id),
                  queryParams: _objectSpread({}, query)
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getTicketById(_x) {
        return _getTicketById.apply(this, arguments);
      }

      return getTicketById;
    }()
  }, {
    key: "getBoardsList",
    value: function () {
      var _getBoardsList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3() {
        var query,
            _args3 = arguments;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                query = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                return _context3.abrupt("return", this._callApi({
                  path: "/v2/ticket/boards",
                  queryParams: _objectSpread({}, query)
                }));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getBoardsList() {
        return _getBoardsList.apply(this, arguments);
      }

      return getBoardsList;
    }()
  }, {
    key: "getTicketTypes",
    value: function () {
      var _getTicketTypes = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4() {
        var query,
            _args4 = arguments;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                query = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
                return _context4.abrupt("return", this._callApi({
                  path: '/v2/ticket/types',
                  queryParams: _objectSpread({}, query)
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getTicketTypes() {
        return _getTicketTypes.apply(this, arguments);
      }

      return getTicketTypes;
    }()
  }, {
    key: "getTicketRequesters",
    value: function () {
      var _getTicketRequesters = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5() {
        var query,
            _args5 = arguments;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                query = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
                return _context5.abrupt("return", this._callApi({
                  path: '/v2/ticket/requesters',
                  queryParams: _objectSpread({}, query)
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getTicketRequesters() {
        return _getTicketRequesters.apply(this, arguments);
      }

      return getTicketRequesters;
    }()
  }, {
    key: "getFiltersByTicketType",
    value: function () {
      var _getFiltersByTicketType = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(type) {
        var query,
            _args6 = arguments;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                query = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
                return _context6.abrupt("return", this._callApi({
                  path: "/v2/ticket/types/".concat(type, "/filters"),
                  queryParams: _objectSpread({}, query)
                }));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getFiltersByTicketType(_x2) {
        return _getFiltersByTicketType.apply(this, arguments);
      }

      return getFiltersByTicketType;
    }()
  }, {
    key: "getTicketLabels",
    value: function () {
      var _getTicketLabels = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7() {
        var query,
            _args7 = arguments;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                query = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
                return _context7.abrupt("return", this._callApi({
                  path: '/v2/ticket/labels',
                  queryParams: _objectSpread({}, query)
                }));

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getTicketLabels() {
        return _getTicketLabels.apply(this, arguments);
      }

      return getTicketLabels;
    }()
  }, {
    key: "createTicket",
    value: function () {
      var _createTicket = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8() {
        var data,
            _args8 = arguments;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                data = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
                return _context8.abrupt("return", this._callApi({
                  method: 'POST',
                  path: '/v2/ticket',
                  payload: data
                }));

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function createTicket() {
        return _createTicket.apply(this, arguments);
      }

      return createTicket;
    }()
  }, {
    key: "updateTicket",
    value: function () {
      var _updateTicket = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(id) {
        var data,
            _args9 = arguments;
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                data = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};
                return _context9.abrupt("return", this._callApi({
                  method: 'PUT',
                  path: "/v2/ticket/".concat(id),
                  payload: data
                }));

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function updateTicket(_x3) {
        return _updateTicket.apply(this, arguments);
      }

      return updateTicket;
    }()
  }, {
    key: "createBoard",
    value: function () {
      var _createBoard = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10() {
        var data,
            _args10 = arguments;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                data = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
                return _context10.abrupt("return", this._callApi({
                  method: 'POST',
                  path: '/v2/ticket/board',
                  payload: data
                }));

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function createBoard() {
        return _createBoard.apply(this, arguments);
      }

      return createBoard;
    }()
  }, {
    key: "updateBoard",
    value: function () {
      var _updateBoard = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(id) {
        var data,
            _args11 = arguments;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                data = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : {};
                return _context11.abrupt("return", this._callApi({
                  method: 'PUT',
                  path: "/v2/ticket/board/".concat(id),
                  payload: data
                }));

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function updateBoard(_x4) {
        return _updateBoard.apply(this, arguments);
      }

      return updateBoard;
    }()
  }, {
    key: "addComment",
    value: function () {
      var _addComment = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(id) {
        var data,
            _args12 = arguments;
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                data = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : {};
                return _context12.abrupt("return", this._callApi({
                  method: 'POST',
                  path: "/v2/ticket/".concat(id, "/comments"),
                  payload: data
                }));

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function addComment(_x5) {
        return _addComment.apply(this, arguments);
      }

      return addComment;
    }()
  }, {
    key: "getComments",
    value: function () {
      var _getComments = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13(id) {
        var query,
            _args13 = arguments;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                query = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : {};
                return _context13.abrupt("return", this._callApi({
                  method: 'GET',
                  path: "/v2/ticket/".concat(id, "/comments"),
                  queryParams: _objectSpread({}, query)
                }));

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getComments(_x6) {
        return _getComments.apply(this, arguments);
      }

      return getComments;
    }()
  }, {
    key: "getActivity",
    value: function () {
      var _getActivity = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee14(id) {
        var query,
            _args14 = arguments;
        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                query = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : {};
                return _context14.abrupt("return", this._callApi({
                  method: 'GET',
                  path: "/v2/ticket/".concat(id, "/activity"),
                  queryParams: _objectSpread({}, query)
                }));

              case 2:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getActivity(_x7) {
        return _getActivity.apply(this, arguments);
      }

      return getActivity;
    }()
  }, {
    key: "createLabel",
    value: function () {
      var _createLabel = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee15() {
        var data,
            _args15 = arguments;
        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                data = _args15.length > 0 && _args15[0] !== undefined ? _args15[0] : {};
                return _context15.abrupt("return", this._callApi({
                  method: 'POST',
                  path: '/v2/ticket/label',
                  payload: data
                }));

              case 2:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function createLabel() {
        return _createLabel.apply(this, arguments);
      }

      return createLabel;
    }()
  }, {
    key: "updateLabel",
    value: function () {
      var _updateLabel = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee16(id) {
        var data,
            _args16 = arguments;
        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                data = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : {};
                return _context16.abrupt("return", this._callApi({
                  method: 'PUT',
                  path: "/v2/ticket/label/".concat(id),
                  payload: data
                }));

              case 2:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function updateLabel(_x8) {
        return _updateLabel.apply(this, arguments);
      }

      return updateLabel;
    }()
  }, {
    key: "deleteLabel",
    value: function () {
      var _deleteLabel = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee17() {
        var data,
            _args17 = arguments;
        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                data = _args17.length > 0 && _args17[0] !== undefined ? _args17[0] : {};
                return _context17.abrupt("return", this._callApi({
                  method: 'DELETE',
                  path: "/v2/ticket/label",
                  payload: data
                }));

              case 2:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function deleteLabel() {
        return _deleteLabel.apply(this, arguments);
      }

      return deleteLabel;
    }()
  }]);
  return TicketsApi;
}(_basic_data_hub_api.default);

var _default = TicketsApi;
exports.default = _default;